module.exports = __webpack_public_path__ + "images/top_icon_close.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_close.png
// module id = 898
// module chunks = 124